export const DeviceForAlarmRingTone = {
    none: "NONE",
    watchOnly: "WATCH_ONLY",
    phoneOnly: "PHONE_ONLY",
    phoneAndWatch: "PHONE_AND_WATCH",
  };